export enum WebStorageType {
	LocalStorage = 'LocalStorage',
	SessionStorage = 'SessionStorage',
}
